import React, { Fragment } from 'react';
import cn from 'classnames';
import { dayOfWeekColor, isToday } from './Utils';

const AdminDesignersCalendars = ({ designer, days, handleDesignerClick, selected }) => {
  const { bookings, time_slots: timeSlots } = designer;

  function renderDesignerLine(day) {
    const dateStr = `${day.year}-${day.month}-${day.dom}`;
    const bookingInfo = bookings[dateStr] || [];
    const dayTimeSlots = timeSlots[dateStr] || [];
    const bookingsTotal = bookingInfo.length;
    const dayOff = dayTimeSlots["day_off"] === true;
    const freeTimeSlotsTotal = Object.keys(dayTimeSlots).length - bookingsTotal;
    // const disabledDesigner = (designer.priority || 5) >= 5;
    // '-disabled-designer': disabledDesigner
    return (
      <div key={dateStr} className={cn('calendar-day', '-availability', dayOfWeekColor(day.dow), {'-today': isToday(day), '-day-off': dayOff, '-selected': selected })}>
        {dayOff && 'OFF'}
        {!dayOff && (
          <Fragment>
            <div className={cn('bookings', { '-scheduled-bookings': bookingsTotal > 0 })}>
              {bookingsTotal > 0 ? bookingsTotal : '-'}
            </div>
            <div className={cn('availabilities', {'-any-availabilities': freeTimeSlotsTotal > 0})}>
              {freeTimeSlotsTotal > 0 && (
                `${freeTimeSlotsTotal}`
              )}
            </div>
          </Fragment>
        )}
      </div>
    );
  };

  return (
    <div onClick={() => handleDesignerClick(designer)} className="designer-availability">
      {days.map(day => renderDesignerLine(day))}
    </div>
  );
};
export default AdminDesignersCalendars;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/AdminDesignersCalendars.js